var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "cropperImg",
    attrs: {
      id: "demo"
    }
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.panel,
      expression: "panel"
    }],
    staticClass: "container"
  }, [_c("div", [_c("img", {
    attrs: {
      id: "image",
      src: _vm.url,
      alt: "Picture"
    }
  })]), _c("button", {
    attrs: {
      type: "button",
      id: "button"
    },
    on: {
      click: _vm.crop
    }
  }, [_vm._v("确定")])]), _c("div", [_c("div", {
    staticClass: "show",
    staticStyle: {
      height: "56px",
      width: "56px"
    }
  }, [_c("div", {
    staticClass: "picture",
    staticStyle: {
      height: "56px",
      width: "56px"
    },
    style: "backgroundImage:url(" + _vm.headerImage + ")"
  })]), _c("div", {
    staticStyle: {
      opacity: "0",
      width: "360px",
      position: "absolute",
      top: "0",
      right: "0",
      height: "56px"
    }
  }, [_c("input", {
    staticStyle: {
      height: "56px"
    },
    attrs: {
      type: "file",
      id: "change",
      accept: "image"
    },
    on: {
      change: _vm.change
    }
  }), _c("label", {
    attrs: {
      for: "change"
    }
  })])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };